import { Select, SelectContent, SelectTrigger, SelectItem } from '@shopflo/ui'
import { AmountType, AmountEntitlement, DiscountFieldPaths } from 'src/lib/types/discountsV2'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import FormErrorText from 'src/components/common/FormErrorText'
import DiscountPricingInput from '../../../common/DiscountPricingInput'

const AmountOffUptoPricingInputs = () => {
  const {
    state: { entitlement, errors },
    actions: { setFormState }
  } = useDiscountForm()
  // Cast entitlement to AmountEntitlement as this component is only used for Amount Off Upto
  // which shares the underlying AMOUNT coupon type structure

  return (
    <div className='flex gap-3 w-full pb-6'>
      <div className='flex-1'>
        <DiscountPricingInput error={errors[DiscountFieldPaths.CONCESSION_AMOUNT]} />
        <FormErrorText message={errors[DiscountFieldPaths.CONCESSION_AMOUNT]} />
      </div>
      <div className='flex-1'>
        <Select value='on_product' disabled>
          <SelectTrigger
            className='w-full h-9 bg-zinc-50 rounded-lg opacity-100 cursor-default text-zinc-800'
            showCaret={false}
          >
            <span className='p-1'>On purchased products</span>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value='on_product'>On purchased products</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}

export default AmountOffUptoPricingInputs
